import { ChevronRight } from "lucide-react";
import { Link } from "wouter";
import { useI18n } from "../lib/i18n";

type MobileAccountBreadcrumbProps = {
  currentLabel: string;
  count?: number;
};

/** Account feature roots return directly to the overview, including on direct entry. */
export function MobileAccountBreadcrumb({ currentLabel, count }: MobileAccountBreadcrumbProps) {
  const { t } = useI18n();
  return (
    <nav aria-label={t("dashboard.accountMenu.title")} className="mobile-account-breadcrumb mb-4 flex min-w-0 items-center gap-2 text-sm text-mut sm:hidden">
      <Link href="/dashboard" aria-label={t("profile.backToAccount")}
        className="inline-flex min-h-11 shrink-0 items-center hover:text-navy focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-gold">
        {t("dashboard.accountMenu.account")}
      </Link>
      <ChevronRight className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      {count === undefined ? (
        <span aria-current="page" className="min-w-0 break-words font-bold text-navy">{currentLabel}</span>
      ) : (
        <>
          <h1 aria-current="page" className="mobile-listing-title min-w-0 flex-1 text-sm font-extrabold tracking-tight text-navy">{currentLabel}</h1>
          <span className="mobile-listing-count inline-grid h-6 min-w-6 shrink-0 place-items-center rounded-full bg-navy-50 px-1.5 text-xs font-bold text-navy">{count}</span>
        </>
      )}
    </nav>
  );
}
